/* eslint-disable max-len */
// GENERATED BY process-svg DO NOT EDIT
import React from 'react'
import { Icon, Props } from './Icon'

export const IconPlay = (props: Props) => (
  <Icon {...props}>
    <path className="path1"  fillRule="nonzero" d="M8 5v14l11-7z" />
  </Icon>
)

// for use with mapbox addables.
export const IconPlayString =
  `<svg viewbox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path className="path1"  fillRule="nonzero" d="M8 5v14l11-7z" />
  </svg>`

IconPlay.displayName = 'IconPlay'
